import { useParams } from 'react-router-dom';
import CustomLayout from '../components/custom-layout';
import Starfield from '../backgrounds/starfield';
import { WorkType } from '../types/work';
import Section from '../components/portfolio/section';
import Article from '../components/portfolio/article';
import Content from '../components/portfolio/content';
import workJSON from '../data/work.json';

const Work = () => {
  const { id } = useParams();

  return (
    <CustomLayout
      background={<Starfield />}
    >
      <Section
        id={id}
        title="Work"
        collective="Work"
      >
        {workJSON.workData.map((work: WorkType) => (
          <Article
            key={work.companyName}
            externalUrl
            title={work.companyName}
            type={work.type}
            url={work.companyUrl}
          >
            <Content
              articleName={work.companyName}
              description={work.description}
              exampleAlt={work.example}
              exampleUrl={work.example}
              knowledge={work.knowledge}
              logo={work.logo}
              quote={work.companyQuote}
              references={work.references}
              role={work.role}
            />
          </Article>
        ))}
      </Section>
    </CustomLayout>
  );
};

export default Work;
